import * as React from "react";
import { useNavigate } from "react-router";

import { useCurrentPdf } from "@/modules/chat/hooks/useCurrentPdf";

/** Opens a file-scoped chat for the given file. */
export const useAskFile = () => {
  const { setCurrentPdfId } = useCurrentPdf();
  const navigate = useNavigate();

  return React.useCallback(
    (fileId: string) => {
      setCurrentPdfId(fileId);
      navigate(`/chat/${fileId}`);
    },
    [setCurrentPdfId, navigate],
  );
};
